<body class="ltr  leftmenu">
    <form autocomplete="off" novalidate [formGroup]="TcLcForm">
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <div class=" d-flex align-items-center pl-3">
                                                <!-- <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                    class="mh-45px pb-2"> -->
                                                <div>
                                                    <h3 class="main-content-label mb-1"><b>
                                                            STUDENT REQUESTS
                                                        </b></h3>
                                                    <!-- <p class="text-muted card-sub-title mb-0">
                                                        complaint-form works!
                                                    </p> -->
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                    <hr class="mt-2">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Request For </mat-label>
                                                        <mat-select #select533 class="colorblack"
                                                            formControlName="StuCertificate">
                                                            <mat-select-filter *ngIf="select533.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CdCode'"
                                                                [array]="TCList"
                                                                (filteredReturn)="filterTCList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of filterTCList"
                                                                [value]="item.CdCode" (click)="ShowTable(item.CdCode)">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>

                                                    </mat-form-field>


                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Faculty </mat-label>
                                                        <mat-select disabled #select333 placeholder="FcCode"
                                                            class="colorblack" formControlName="StuFaculty">
                                                            <mat-select-filter *ngIf="select333.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'FcDesc'"
                                                                [array]="facultyList"
                                                                (filteredReturn)=" filteredFacultyList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredFacultyList"
                                                                [value]="item.FcCode">
                                                                {{item.FcDesc}}
                                                            </mat-option>
                                                        </mat-select>

                                                    </mat-form-field>


                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Course </mat-label>
                                                        <mat-select disabled #select343 placeholder="CoCode"
                                                            class="colorblack" formControlName="StuCourse">
                                                            <mat-select-filter *ngIf="select343.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="courseList"
                                                                (filteredReturn)=" filteredCourseList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCourseList"
                                                                [value]="item.CoCode">
                                                                {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> College </mat-label>
                                                        <mat-select [disabled]="ShowCollege" #select384 class="colorblack"
                                                            formControlName="StuCollege">
                                                            <mat-select-filter *ngIf="select384.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                [array]="CollegeList"
                                                                (filteredReturn)=" filteredCollegeList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredCollegeList"
                                                                [value]="item.CgCode">
                                                                {{item.CgName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3" *ngIf="TcLcForm.value['StuCertificate'] !== 'LANG'">
                                        <div class="form-group">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label> Exam </mat-label>
                                            <mat-select 
                                            [disabled]="ShowExam" 
                                            #select363 
                                            class="colorblack"
                                            formControlName="StuExam"
                                            (selectionChange)="onExamChange($event)">
                                                
                                                <mat-select-filter *ngIf="select363.focused"
                                                    [placeholder]="'Filter'" 
                                                    [displayMember]="'EmName'"
                                                    [array]="examList"                                     
                                                    (filteredReturn)="filteredExamList = $event">
                                                </mat-select-filter>

                                                <mat-option *ngFor="let item of filteredExamList" [value]="item.EmId">
                                                {{item.EmName}}
                                                </mat-option>
                                            </mat-select>
                                            </mat-form-field>
                                        </div>
                                        </div>

                                        <div class="col-sm-3" *ngIf="TcLcForm.value['StuCertificate'] !== 'LANG'">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Branch </mat-label>
                                                        <mat-select disabled #select353 placeholder="StrName"
                                                            class="colorblack" formControlName="StuBranch">
                                                            <mat-select-filter *ngIf="select353.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'StrName'"
                                                                [array]="courseStreamList"
                                                                (filteredReturn)=" filteredStreamList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredStreamList"
                                                                [value]="item.StrId">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            </div>

<div class="col-sm-12" *ngIf="(TcLcForm.value['StuCertificate'] === 'ASC' || TcLcForm.value['StuCertificate'] === 'RET') && ascCutoffChecked && !ascCutoffValid">
    <div class="alert alert-danger mb-2" role="alert">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        <b>{{ ascCutoffMessage || ' Photocopy of answerbook Is Not Available At This Time' }}</b>
    </div>
</div>

<!-- Subject Dropdown -->
<div class="col-sm-3" *ngIf="Subject && TcLcForm.value['StuCertificate'] !== 'LANG'">
    <div class="form-group">
        <mat-form-field appearance="outline" class="example-full-width">
            <mat-label> Subject </mat-label>

            <mat-select #subjectSelect class="colorblack" formControlName="SelectedSubject" multiple>

                <!-- Filter -->
                <mat-select-filter
                    *ngIf="subjectSelect.focused"
                    [placeholder]="'Filter'"
                    [displayMember]="'SubName'"
                    [array]="subjectList"
                    (filteredReturn)="filteredSubjectList = $event">
                </mat-select-filter>

                <!-- Select All Option -->
                <mat-option (click)="onSelectAllChange()" class="select-all-option">
                    <span><b>Select All</b></span>
                </mat-option>

                <mat-divider></mat-divider>

                <!-- Options -->
                <mat-option *ngFor="let s of filteredSubjectList" [value]="s.EsId">
                    {{ s.SubName }}
                </mat-option>

            </mat-select>
        </mat-form-field>

        <mat-error class="margin_tp sz float-left"
            *ngIf="TcLcForm.controls['SelectedSubject'].touched &&
                    TcLcForm.controls['SelectedSubject'].errors?.required">
            Mandatory
        </mat-error>
    </div>
</div>

<!-- Subject Head Dropdown - filtered by selected subjects -->
<div class="col-sm-3" *ngIf="Subject && TcLcForm.value['StuCertificate'] !== 'LANG'">
    <div class="form-group">
        <mat-form-field appearance="outline" class="example-full-width">
            <mat-label> Subject Head </mat-label>

            <mat-select #subjectHeadSelect class="colorblack" 
                        formControlName="SelectedSubjectHead" 
                        multiple
                        (selectionChange)="onSubjectHeadChange($event)">

                <!-- Filter -->
                <mat-select-filter
                    *ngIf="subjectHeadSelect.focused"
                    [placeholder]="'Filter'"
                    [displayMember]="'EsName'"
                    [array]="subjectHeadList"
                    (filteredReturn)="filteredSubjectHeadList = $event">
                </mat-select-filter>

                <!-- Select All Option -->
                <mat-option (click)="onSelectAllSubjectHeadsChange()" class="select-all-option">
                    <span><b>Select All</b></span>
                </mat-option>

                <mat-divider></mat-divider>

                <!-- Options -->
                <mat-option *ngFor="let h of filteredSubjectHeadList" [value]="h.EsId">
                    {{ h.EsName }}
                </mat-option>

            </mat-select>
        </mat-form-field>
    </div>
</div>

                                        <div *ngIf="College && TcLcForm.value['StuCertificate'] !== 'LANG'" class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> Destination College </mat-label>
                                                            <mat-select #select383 class="colorblack"
                                                                formControlName="DestCollege">
                                                                <mat-select-filter *ngIf="select383.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                    [array]="DestcollegeList"
                                                                    (filteredReturn)=" filteredDestCollegeList =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of  filteredDestCollegeList"
                                                                    [value]="item.CgCode">
                                                                    {{item.CgName}}
                                                                </mat-option>
                                                            </mat-select>
    
                                                        </mat-form-field>
                                                        <mat-error class="margin_tp sz float-left"
                                                            *ngIf="TcLcForm.controls['DestCollege'].touched && TcLcForm.controls['DestCollege'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
    
                                                    </div>
                                                </div>
                                        </div>
                                        <div *ngIf="University && TcLcForm.value['StuCertificate'] !== 'LANG'" class="col-sm-3">
                                            
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> Destination University </mat-label>
                                                            <mat-select #select383 class="colorblack"
                                                                formControlName="DestCollege">
                                                                <mat-select-filter *ngIf="select383.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'UniName'"
                                                                    [array]="DestUniList"
                                                                    (filteredReturn)=" filteredDestUniList =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of  filteredDestUniList"
                                                                    [value]="item.UniCode">
                                                                    {{item.UniName}}
                                                                </mat-option>
                                                                <mat-option [value] = "'Other'" (click)="TypeUni()">Other</mat-option>
                                                            </mat-select>
    
                                                        </mat-form-field>
                                                        <mat-error class="margin_tp sz float-left"
                                                            *ngIf="TcLcForm.controls['DestCollege'].touched && TcLcForm.controls['DestCollege'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
    
                                                    </div>
                                                </div>
                                            
                                        </div>
                                        <div *ngIf="Other" class="col-sm-3">
                                            <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Other University</mat-label>
                                                        <input formControlName="Other" matInput placeholder="Other University" class="color"
                                                            maxlength="1000">
                                                    </mat-form-field>
                                            </div>
                                        </div>
                                        

                                        <div class="col-sm-3" *ngIf="TcLcForm.value['StuCertificate'] !== 'LANG'">
                                            <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Reason</mat-label>
                                                        <input formControlName="reason" matInput placeholder="Reason" class="color"
                                                            maxlength="1000">
                                                    </mat-form-field>
                                            </div>
                                        </div>
                                    </div>

                                <!-- For Language Certificate fields: Mobile, Email, Address -->
                                <div class="row" *ngIf="TcLcForm.value['StuCertificate'] === 'LANG'">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Mobile No</mat-label>
                                                <input formControlName="mobileNo" matInput placeholder="Mobile Number"
                                                    maxlength="10">
                                                <mat-error *ngIf="TcLcForm.get('mobileNo')?.hasError('required') && TcLcForm.get('mobileNo')?.touched">
                                                    Mobile number is required
                                                </mat-error>
                                                <mat-error *ngIf="TcLcForm.get('mobileNo')?.hasError('pattern')">
                                                    Enter valid 10-digit mobile number
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Email</mat-label>
                                                <input formControlName="email" matInput placeholder="Email Address"
                                                    type="email">
                                                <mat-error *ngIf="TcLcForm.get('email')?.hasError('required') && TcLcForm.get('email')?.touched">
                                                    Email is required
                                                </mat-error>
                                                <mat-error *ngIf="TcLcForm.get('email')?.hasError('email')">
                                                    Enter valid email address
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Address</mat-label>
                                                <textarea formControlName="address" matInput placeholder="Address"
                                                    rows="2" maxlength="500"></textarea>
                                                <mat-error *ngIf="TcLcForm.get('address')?.hasError('required') && TcLcForm.get('address')?.touched">
                                                    Address is required
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="TcLcForm.value['StuCertificate'] === 'LANG'">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Delivery option</mat-label>
                                                    <mat-select class="color" formControlName="DeliveryOpt">
                                                        <mat-option *ngFor="let item of deliveryList" [value]="item.dropdownValue">
                                                            {{item.Value}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-3" *ngIf="TcLcForm.get('DeliveryOpt')?.value === 'Soft' || TcLcForm.get('DeliveryOpt')?.value === 'Both'">
                                        <div class="form-group">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Email Id</mat-label>
                                                <input formControlName="emailId" matInput placeholder="Email Id" class="color">
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="col-sm-2" *ngIf="TcLcForm.get('DeliveryOpt')?.value === 'Hard' || TcLcForm.get('DeliveryOpt')?.value === 'Both'">
                                        <div class="form-group">
                                            <section class="example-section mt-2">
                                                <mat-checkbox class="example-margin" formControlName="isSameAddr">
                                                    Same as above
                                                </mat-checkbox>
                                            </section>
                                        </div>
                                    </div>

                                    <div class="col-sm-3" *ngIf="TcLcForm.get('DeliveryOpt')?.value === 'Hard' || TcLcForm.get('DeliveryOpt')?.value === 'Both'">
                                        <div class="form-group">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Postal Address</mat-label>
                                                <input [readonly]="isReadonly" formControlName="postalAdd"
                                                    matInput placeholder="Postal Address" class="color">
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="col-sm-3" *ngIf="TcLcForm.get('DeliveryOpt')?.value === 'Hard' || TcLcForm.get('DeliveryOpt')?.value === 'Both'">
                                        <div class="form-group">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Delivery Location</mat-label>
                                                <mat-select class="color" formControlName="deliverAt">
                                                    <mat-option *ngFor="let item of deliveryOptionList" [value]="item.deliveryOptionValue">
                                                        {{item.Value}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>

                                    <div *ngIf="DocTable" class="row clearfix">
                                        <div class="table-responsive">
                                            <table id="datatable" class="table tw table-bordered text-nowrap text-left">
                                                <thead>
                                                    <tr class="text-left">
                            
                                                        <th class="f600" style="width: 20%;">
                                                            Document Name
                                                        </th>
                                                        <th class="f600 " style="width: 20%;" >
                                                            Document Upload
                                                        </th>
                                                        <th style="width: 10%;" *ngIf="DocView">
                                                            View
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody id="table_data" formArrayName="arrData">
                                                    <tr class="text-center" [formGroupName]="i" 
                                                        *ngFor="let row of TcLcForm.get('arrData')['controls']; let i = index; let last = last" 
                                                        >
                            
                                                        <td>
                                                            <mat-form-field class="example-full-width" appearance="outline">
                                                                <mat-label class="lable_style2">Document Name :</mat-label>
                                                                <input type="text" readonly formControlName="DocumentName" matInput
                                                                    placeholder="Document Name">
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="row.controls.DocumentName.touched && row.controls.DocumentName.errors?.required">
                                                                    Mandatory
                                                                </mat-error>
                                                            </mat-form-field>
                                                        </td>
                                                        <td >
                                                            <mat-form-field class="example-full-width" appearance="outline">
                                                                <input type="text"  readonly hidden matInput formControlName="DocumentFile" />
                                                                <input type="file"  id="i" placeholder="File" accept=".pdf" aria-label="FIle"
                                                                    formControlName="docFile" (change)="onChange($event,i)"
                                                                    onkeydown="return (event.keyCode!=13);" class="file-input"/>
                                                                    
                                                            <mat-error class="mt-1"
                                                            *ngIf="row.controls.DocumentFile.touched && row.controls.DocumentFile.errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                            </mat-form-field>
                                                        </td>
                                                        <!-- <td *ngIf="isFileInputNot">
                                                            {{row.value.DocumentName}}
                                                        </td> -->
                                                        <td (click)="showbase64(row)" *ngIf="DocView">
                                                            <a><label class="blue_col">View</label></a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <h6 class="mb-3 mt-3 redCol"><b>
                                                * Note: Please upload only PDF file.</b></h6>
                                       
                                    </div>
                                    <!--  -->
                                    <button *ngIf="SaveBtn" type="button" (click)="Save()" 
                                        [disabled]="SaveDisabled || ((TcLcForm.value['StuCertificate'] === 'ASC' || TcLcForm.value['StuCertificate'] === 'RET') && ascCutoffChecked && !ascCutoffValid)"
                                        class="btn btn-primary btn-icon-text floatright fr sz mt-1">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/images/save.gif"
                                                style="margin-right: 5px;">
                                            Save
                                        </span>
                                    </button>
                                    <button *ngIf="UpdateBtn" type="button" (click)="Update()" [disabled]="UpdateDisabled"
                                        class="btn btn-primary btn-icon-text floatright fr sz mt-1">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/images/save.gif"
                                                style="margin-right: 5px;">
                                            Update
                                        </span>
                                    </button>
                                    
                                    <button *ngIf="PayFee" type="button" (click)="PayFees()" [disabled]="PayDisabled"
                                        class="btn btn-primary btn-icon-text floatright fr mr-3 mt-1">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/images/pay-per-click.gif" 
                                                style="margin-right: 5px;">
                                                Pay
                                        </span>
                                    </button>
                                    <button *ngIf="PayRecpt" type="button" (click)="getFeeTempData()"
                                        class="btn btn-primary pay btn-icon-text floatright fr mr-3 mt-1">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/images/pay-per-click.gif" 
                                                style="margin-right: 5px;">
                                                Payment Receipt
                                        </span>
                                    </button>

                                    <button *ngIf="shouldShowLanguageDownloadButton()" type="button" 
                                        (click)="downloadLanguageCertificate()"
                                        [disabled]="isLanguageDownloadDisabled()"
                                        class="btn btn-primary btn-icon-text floatright fr mr-3 mt-1">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/images/arrow (1).png"
                                                style="margin-right: 5px;">
                                            Download
                                        </span>
                                    </button>

                                    <button id="Back" type="button" (click)="Reset()"
                                        class="btn btn-primary btn-icon-text floatright fr mr-3 mt-1">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/images/refresh.gif">
                                            Reset
                                        </span>
                                    </button>

                                    <!-- <div *ngIf="Table" class="table-responsive table-container tab mt-1"> -->
                                        <div *ngIf="Table && TcLcForm.value['StuCertificate'] !== 'ASC' && TcLcForm.value['StuCertificate'] !== 'RET'" class="table-responsive table-container tab mt-1">
                                        <table  class="table table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr class="text-left">
                                                   
                                                    <th class="f600">
                                                        Id
                                                    </th>
                                                    <th class="f600">
                                                        Request Type
                                                    </th>
                                                    <th class="f600">
                                                        Course Name
                                                    </th>
                                                    <th *ngIf="CertStatus != 'ADMC'" class="f600">
                                                        Fee Status
                                                    </th>
                                                    <th class="f600">
                                                        Comment
                                                    </th>
                                                    <th class="f600">
                                                        Action
                                                    </th>
                                                    <th class="f600">
                                                        Status By
                                                    </th>
                                                    <th class="f600" *ngIf="Approved">
                                                        Certificate
                                                        <!-- Download -->
                                                    </th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let tclc of TclcData; let i = index" >
                                                         <!-- <td *ngIf="ScrutinyTable.length > inteckCount" class="colorChnage" (click)="details(scrutiny)">
                                                            <a >{{scrutiny.StuFirstNameEng}}  {{ scrutiny.StuMidNameEng}}  {{ scrutiny.StuLastNameEng}}</a>
                                                        </td> -->
                                                        
                                                        <td class="labelStyle">
                                                            {{tclc.TclcId}}  
                                                        </td>
                                                        <td>
                                                            {{tclc.CertType == 'ADMC' ? 'Admission Cancellation' :
                                                        (tclc.CertType == 'TC' ? 'Transfer Certificate' : (tclc.CertType
                                                        == 'LC' ? 'Leaving Certificate' : (tclc.CertType == 'MC' ? 'Migration Certificate' : 'Transcript Certificate')))}}  
                                                        </td>
                                                        <td>
                                                            {{tclc.CoName}}
                                                        </td>
                                                        <td *ngIf="tclc.CertType != 'ADMC'">
                                                            {{tclc.FeeStatus}}
                                                        </td>
                                                        <td>
                                                            {{tclc.Comment}}
                                                        </td>
                                                        <td>
                                                            {{Status}}
                                                        </td>
                                                        <td>
                                                            {{tclc.StatusBy}}
                                                        </td>
                                                        <td *ngIf="Approved">
                                                            <img alt="Logo" (click)="dowload(tclc)" src="../../assets/images/arrow (1).png" class="mh-45px curr pb-2">
                                                        </td>
                                                        <!-- <tr>
                                                            <a class="btn-floating"
                                                            (click)="openModal(scrutiny)">
                                                            <i class="fa fa-eye"></i>
                                                        </a>
                                                        </td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- NEW: ASC / RET Payment Status Table - shows Subject + Subject Head with payment status -->
                                    <div *ngIf="(TcLcForm.value['StuCertificate'] === 'ASC' || TcLcForm.value['StuCertificate'] === 'RET') && TclcData && TclcData.length > 0" class="table-responsive table-container tab mt-1">
                                        <table class="table table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr class="text-left">
                                                    <th class="f600">Id</th>
                                                    <th class="f600">Request Type</th>
                                                    <th class="f600">Subject</th>
                                                    <th class="f600">Subject Head</th>
                                                    <th class="f600">Fee Status</th>
                                                    <th class="f600">Comment</th>
                                                    <th class="f600">Status</th>
                                                    <th class="f600">Status By</th>
                                                    <th class="f600">Download</th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let tclc of TclcData; let i = index">
                                                    <td class="labelStyle">{{tclc.TclcId}}</td>
                                                    <td>{{ TcLcForm.value['StuCertificate'] === 'RET' ? 'Retotaling of marks' : 'Photocopy of answerbook' }}</td>
                                                    <td>{{ getSubjectNameById(tclc.StuSubId) || tclc.EsName || tclc.StuSubId }}</td>
                                                    <td>{{ getSubjectHeadNameById(tclc.StuSubId) || tclc.EsName || tclc.StuSubId }}</td>
                                                    <td>{{tclc.FeeStatus == 'Y' ? 'Paid' : 'Unpaid'}}</td>
                                                    <td>{{tclc.Comment}}</td>
                                                    <td>{{Status}}</td>
                                                    <td>{{tclc.StatusBy}}</td>
                                                    <td>
                                                        <ng-container *ngIf="shouldShowAnswerSheetButtonForRow(tclc); else notUploaded">
                                                            <img alt="Download"
                                                                 (click)="downloadAnswerSheetCopyForRow(tclc)"
                                                                 [style.opacity]="isDownloadDisabledForRow(tclc) ? 0.4 : 1"
                                                                 [style.pointer-events]="isDownloadDisabledForRow(tclc) ? 'none' : 'auto'"
                                                                 src="../../assets/images/arrow (1).png"
                                                                 class="mh-45px curr pb-2">
                                                        </ng-container>
                                                        <ng-template #notUploaded>
                                                            <span class="text-muted" style="font-size:12px;">Not yet uploaded</span>
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>